import React, { useState, useEffect } from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonList, IonItem, IonLabel, IonInput } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import config from '../config'; // Import config

function AdminDashboard() {
  const history = useHistory();
  const [pendingTrees, setPendingTrees] = useState([]);
  const [announcement, setAnnouncement] = useState('');

  useEffect(() => {
    fetch(`${config.API_BASE_URL}/admin/pending-trees`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => res.json())
      .then(data => setPendingTrees(data));
  }, []);

  const approveTree = (id) => {
    fetch(`${config.API_BASE_URL}/admin/approve-tree/${id}`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    }).then(() => window.location.reload());
  };

  const rejectTree = (id) => {
    fetch(`${config.API_BASE_URL}/admin/reject-tree/${id}`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    }).then(() => window.location.reload());
  };

  const saveSettings = () => {
    fetch(`${config.API_BASE_URL}/admin/settings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ announcement })
    }).then(() => alert('Settings saved!'));
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Admin Dashboard</IonTitle>
          <IonButton slot="end" onClick={() => history.push('/')}>Home</IonButton>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <h2>Pending Trees</h2>
        <IonList>
          {pendingTrees.map(tree => (
            <IonItem key={tree.id}>
              <IonLabel>{tree.name}</IonLabel>
              <IonButton slot="end" onClick={() => approveTree(tree.id)}>Approve</IonButton>
              <IonButton slot="end" onClick={() => rejectTree(tree.id)}>Reject</IonButton>
            </IonItem>
          ))}
        </IonList>
        <h2>Site Settings</h2>
        <IonItem>
          <IonLabel position="stacked">Announcement</IonLabel>
          <IonInput value={announcement} onIonChange={e => setAnnouncement(e.target.value)}></IonInput>
        </IonItem>
        <IonButton expand="block" onClick={saveSettings}>Save Settings</IonButton>
      </IonContent>
    </IonPage>
  );
}

export default AdminDashboard;